import React, { useState, useEffect } from "react";
import EmployeeForm from "../Components/EmployeeForm";

const EmployeeList = () => {
  const [editingEmployee, setEditingEmployee] = useState(null);
  const [formOpen, setFormOpen] = useState(false);
  const [employees, setEmployees] = useState(() => {
    // localStorage'dan verileri oku
    const savedEmployees = localStorage.getItem('employees');
    if (savedEmployees) {
      try {
        return JSON.parse(savedEmployees);
      } catch (error) {
        console.error('localStorage verisi yüklenirken hata:', error);
        return getDefaultEmployees();
      }
    }
    return getDefaultEmployees();
  });

  function getDefaultEmployees() {
    return [
      {
        id: 1,
        name: "Ahmet Yılmaz",
        position: "Yazılım Geliştirici",
        email: "ahmet@mail.com",
      },
      {
        id: 2,
        name: "Ayşe Demir",
        position: "Proje Yöneticisi",
        email: "ayse@mail.com",
      },
    ];
  }

  // Employees değiştiğinde localStorage'a kaydet
  useEffect(() => {
    localStorage.setItem('employees', JSON.stringify(employees));
  }, [employees]);

  // EKLEME İŞLEMİ
  const addEmployee = (newEmp) => {
    setEmployees([...employees, newEmp]);
    setFormOpen(false);
    window.alert(`"${newEmp.name}" adlı personel başarıyla eklendi! ✓`);
  };
  
  // SİLME İŞLEMİ (Onaylama ile)
  const deleteEmployee = (id, empName) => {
    if (window.confirm(`"${empName}" adlı personeli silmek istediğinize emin misiniz?`)) {
      const updatedEmployees = employees.filter((emp) => emp.id !== id);
      setEmployees(updatedEmployees);
      window.alert(`"${empName}" adlı personel başarıyla silindi! ✓`);
    }
  };
  
  // GÜNCELLEME İŞLEMİ
  const updateEmployee = (updatedEmp) => {
    setEmployees(employees.map(emp => (emp.id === updatedEmp.id ? updatedEmp : emp)));
    setEditingEmployee(null);
    setFormOpen(false);
    window.alert(`"${updatedEmp.name}" adlı personel başarıyla güncellendi! ✓`);
  };

  // VAZGEÇ İŞLEMİ
  const cancelEditing = () => {
    setEditingEmployee(null);
    setFormOpen(false);
  };

  // Yeni Personel Ekle Butonuna Basıldığında
  const handleAddNew = () => {
    setEditingEmployee(null);
    setFormOpen(true);
  };

  return (
    <div className="app-container">
      {/* Header */}
      <div className="app-header">
        <div className="header-content">
          <h1 className="app-title">👥 Personel Kayıt Sistemi</h1>
          <p className="app-subtitle">Personel bilgilerinizi kolayca yönetin</p>
        </div>
      </div>

      <div className="main-content">
        {/* Form Section - Conditionally Rendered */}
        {formOpen && (
          <div className="form-section">
            <div className="form-container">
              <EmployeeForm 
                addEmployee={addEmployee} 
                editingEmployee={editingEmployee}
                updateEmployee={updateEmployee}
                cancelEditing={cancelEditing}
              />
            </div>
          </div>
        )}

        {/* Employee List Section */}
        <div className="list-section">
          <div className="list-header">
            <h2 className="list-title">Personel Listesi</h2>
            {!formOpen && (
              <button 
                className="btn-add-new"
                onClick={handleAddNew}
              >
                <span className="btn-icon">+</span>
                <span className="btn-text">Yeni Personel Ekle</span>
              </button>
            )}
          </div>

          {employees.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">📋</div>
              <p className="empty-title">Henüz personel kaydı yoktur</p>
              <p className="empty-subtitle">Başlamak için "Yeni Personel Ekle" butonuna tıklayın</p>
            </div>
          ) : (
            <div className="table-wrapper">
              <div className="table-responsive">
                <table className="employees-table">
                  <thead>
                    <tr>
                      <th>👤 Ad Soyad</th>
                      <th>💼 Pozisyon</th>
                      <th>📧 E-posta</th>
                      <th>⚙️ İşlemler</th>
                    </tr>
                  </thead>
                  <tbody>
                    {employees.map((emp) => (
                      <tr key={emp.id}>
                        <td className="name-cell">
                          <strong>{emp.name}</strong>
                        </td>
                        <td className="position-cell">
                          {emp.position || '-'}
                        </td>
                        <td className="email-cell">
                          {emp.email}
                        </td>
                        <td className="action-cell">
                          <button 
                            className="btn-action btn-edit"
                            onClick={() => {
                              setEditingEmployee(emp);
                              setFormOpen(true);
                            }}
                            title="Personeli düzenle"
                          >
                            ✎ Güncelle
                          </button>
                          <button
                            className="btn-action btn-delete"
                            onClick={() => deleteEmployee(emp.id, emp.name)}
                            title="Personeli sil"
                          >
                            🗑 Sil
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmployeeList;
